import { render, staticRenderFns } from "./UiWindow.vue?vue&type=template&id=503a1a2e&scoped=true&"
import script from "./UiWindow.vue?vue&type=script&lang=js&"
export * from "./UiWindow.vue?vue&type=script&lang=js&"
import style0 from "./UiWindow.vue?vue&type=style&index=0&id=503a1a2e&lang=scss&scoped=true&"
import style1 from "./UiWindow.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./UiWindow.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a1a2e",
  null
  
)

export default component.exports